import { cn } from '@/lib/utils';

interface CoveLogoProps {
  className?: string;
}

export function CoveLogo({ className }: CoveLogoProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      {/* Logo Icon */}
      <div className="relative h-8 w-8">
        <svg viewBox="0 0 32 32" fill="none" className="h-full w-full">
          <defs>
            <linearGradient id="cove-gradient" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
              <stop stopColor="hsl(262, 83%, 58%)" />
              <stop offset="1" stopColor="hsl(280, 80%, 60%)" />
            </linearGradient>
          </defs>
          {/* Sound waves */}
          <path
            d="M8 16C8 11 11 8 16 8C21 8 24 11 24 16C24 21 21 24 16 24C11 24 8 21 8 16Z"
            fill="url(#cove-gradient)"
            fillOpacity="0.2"
          />
          <path
            d="M6 16C6 9.5 10 6 16 6C22 6 26 9.5 26 16C26 22.5 22 26 16 26C10 26 6 22.5 6 16Z"
            stroke="url(#cove-gradient)"
            strokeWidth="1.5"
            fill="none"
          />
          <circle cx="16" cy="16" r="4" fill="url(#cove-gradient)" />
        </svg>
      </div>
      
      {/* Text */}
      <span className="text-xl font-bold tracking-tight bg-gradient-to-r from-primary to-purple-400 bg-clip-text text-transparent">
        Cove
      </span>
    </div>
  );
}
